/**
 * Registers the companion's EdgeScript tools (`script-tools.ts`) on demand. Same gate
 * shape as `lazy-script-panel.tsx`: the flag expression is repeated inline so the
 * bundler drops the dynamic import (and the language chunk, the tool schemas and the
 * language text behind it) from user builds. Keep it identical to `EDGESCRIPT_ENABLED`
 * in `flags.ts` (the unit test pins them).
 *
 * Called by the companion action host once `edgescript-release` is on for this user,
 * so a user without the flag never registers the tools or sends them to the
 * companion. Registration is idempotent and lasts until reload: a flag that turns off
 * mid-session leaves them registered. A rollout gate, not a security boundary.
 */
export const loadScriptTools: (() => Promise<void>) | null =
  import.meta.env.DEV ||
  ((import.meta.env.MODE === 'staging' || import.meta.env.MODE === 'prod') &&
    import.meta.env.VITE_EDGESCRIPT === 'true')
    ? () => import('./script-tools').then((m) => m.registerScriptTools())
    : null

/**
 * draw_from_script (`draw-from-script.ts`), the EdgeScript half of the companion's chart
 * drawing tools: the same build gate, and the host loads it only with both
 * `edgescript-release` and `aichartdrawing-release` on.
 */
export const loadDrawFromScriptTool: (() => Promise<void>) | null =
  import.meta.env.DEV ||
  ((import.meta.env.MODE === 'staging' || import.meta.env.MODE === 'prod') &&
    import.meta.env.VITE_EDGESCRIPT === 'true')
    ? () => import('./draw-from-script').then((m) => m.registerDrawFromScriptTool())
    : null
